import type { Locale } from '@susu/headless-commerce/config/locale'
import { NavCard } from '@susu/headless-commerce/features/navigation/components/NavCard/NavCard'
import type { Navigation } from '@susu/headless-commerce/features/navigation/domain'
import { generateIdentifier } from '@susu/headless-commerce/utils/identifier'
import classNames from 'classnames'
import { Fragment } from 'react'
import styles from './NavCards.module.scss'

export type NavCardsProps = {
  className?: string
  navigation: Navigation
  locale: Locale
}

export const NavCards = ({ className, navigation, locale }: NavCardsProps) => {
  const cardsClass = classNames(styles['nav__cards'], 'nav__cards', className)

  return (
    <div className={cardsClass} data-testid="nav-cards">
      {navigation.groups?.map((group) => {
        return (
          <Fragment key={generateIdentifier()}>
            {group.cards?.map((item) => {
              return (
                <NavCard
                  item={item}
                  key={generateIdentifier()}
                  locale={locale}
                />
              )
            })}
          </Fragment>
        )
      })}
    </div>
  )
}
